import script from "./z-foot.vue?vue&type=script&setup=true&lang=js"
export * from "./z-foot.vue?vue&type=script&setup=true&lang=js"

import "./z-foot.vue?vue&type=style&index=0&id=1af4973c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af4973c"]])

export default __exports__